import React from "react";
import "./EndPage.css";

const EndPageModal = () => {
  return (
    <div className="content">
      <div className="wrapper-1">
        <div className="wrapper-2">
          <h1>Thank you !</h1>
          {/* <p>thank you for volunteering yourself to be a student </p> */}
          <p> An email confirmation will be sent to you shortly. </p>
        </div>
      </div>
      <p className="product">
        Designed & Powered by{" "}
        <a href="https://blackwinstech.com/" rel="noreferrer" target="_blank">
          {" "}
          Blackwins Tech Solutions
        </a>
      </p>
    </div>
  );
};

export default EndPageModal;
